import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Lock } from "lucide-react";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Checkout from "@/pages/Checkout";
import OrderPage, { TrackForm } from "@/pages/OrderPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminAmazon from "@/pages/admin/AdminAmazon";
import AdminReviews from "@/pages/admin/AdminReviews";
import Wishlist, { Unsubscribe } from "@/pages/Wishlist";
import { WishlistProvider } from "@/context/WishlistContext";
import LegalPage, { LegalLinks } from "@/pages/LegalPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const PAYMENTS = ["Visa", "Mastercard", "American Express", "Apple Pay", "Google Pay"];

const StoreLayout = () => (
  <>
    <Header />
    <Outlet />
    <CartDrawer />
    <footer className="border-t border-[#0F0F0F] mt-16">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-8 flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-[#0F0F0F]/15" data-testid="footer-payments">
        <div className="flex items-center gap-2 text-sm">
          <Lock size={16} strokeWidth={1.5} />
          <span>Pagamenti sicuri e criptati con <b>Stripe</b></span>
        </div>
        <div className="flex flex-wrap gap-2">
          {PAYMENTS.map((m) => (
            <span key={m} data-testid={`payment-method-${m.toLowerCase().replace(/ /g, "-")}`}
              className="bg-white border border-[#0F0F0F] px-3 py-1.5 font-mono text-xs font-semibold">{m}</span>
          ))}
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 border-b border-[#0F0F0F]/15">
        <LegalLinks />
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-8 flex flex-col md:flex-row justify-between gap-2">
        <span className="font-display font-black">SCONTO.MARKET</span>
        <span className="tag text-[#555]">© 2026 · Spedizione gratuita in tutta Italia</span>
      </div>
    </footer>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <WishlistProvider>
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/prodotto/:id" element={<ProductPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/ordine/:code" element={<OrderPage />} />
                <Route path="/traccia" element={<TrackForm />} />
                <Route path="/pagamento/successo" element={<PaymentSuccess />} />
                <Route path="/pagamento/annullato" element={<PaymentCancel />} />
                <Route path="/preferiti" element={<Wishlist />} />
                <Route path="/avvisi/disiscriviti/:token" element={<Unsubscribe />} />
                <Route path="/:slug" element={<LegalPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="prodotti" element={<AdminProducts />} />
                <Route path="ordini" element={<AdminOrders />} />
                <Route path="amazon" element={<AdminAmazon />} />
                <Route path="recensioni" element={<AdminReviews />} />
              </Route>
            </Routes>
            <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, border: "1px solid #0F0F0F" } }} />
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
